/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
// import { FC, ReactNode } from 'react';
// import { Box, alpha, lighten, useTheme } from '@mui/material';
// import { Outlet } from 'react-router-dom';
// import "./SidebarLayout.css"
// import Sidebar from './Sidebar';
// import Header from './Header';
// eslint-disable-next-line import/no-extraneous-dependencies
import io from 'socket.io-client';

import { FC, ReactNode, useEffect } from 'react';
import { Box, alpha, lighten, useTheme } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import './SidebarLayout.css';
import Sidebar from './Sidebar';
import Header from './Header';
import { SOCKET_URL } from 'src/utils/authService';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
// import { setNotifications } from 'src/redux-store/slices/notificationSlice';
import toast from 'react-hot-toast';
// import { handleGetNotification } from 'src/utils/sendNotification';
import { setSessionData } from 'src/utils/CommonFunctions';

interface SidebarLayoutProps {
  children?: ReactNode;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SidebarLayout: FC<SidebarLayoutProps> = ({ children }) => {
  // const theme = useTheme();

  // const location = useLocation();
  // const path = location?.pathname;

  // const dispatch = useDispatch()
  // const userDetails = useSelector((store: RootState) => store.user.userDetails);

  // const list = useSelector((state: any) => state.notifications.notifications)
  // const currentTownshipDetails = useSelector(
  //   (state: RootState) => state?.township?.townshipDetails
  // );
  // const token = getAccessToken()

  // const IsDashboard = userDetails?.UserRole === 'Super Admin' ? -1 : ((path.indexOf('dashboard') !== -1 || path.indexOf('payment-methods') !== -1) ? 1 : -1);

  // const initSocketConnection = () => {
  //   const query = {
  //     UserID: userDetails?.UserID,
  //     TownshipID: currentTownshipDetails?.id,
  //   };

  //   const newSocket = io(SOCKET_URL, {
  //     reconnectionAttempts: 2,  // Will try to reconnect 2 times
  //     reconnectionDelay: 1000,  // Wait 1 second between attempts
  //     // Disable auto connect to handle connection manually
  //     // autoConnect: false,
  //     query
  //   });
  //   newSocket.on("connect", () => {
  //   });

  //   newSocket.on('notification', (data) => {
  //     toast.success(data?.message)
  //     handleGetNotification(dispatch)
  //   });

  //   dispatch(setSocket(newSocket));
  // };

  // useEffect(() => {
  //   // if (!token) navigate('/')
  //   if (token) {
  //     setSessionData('Login_Sucess', 'true');
  //     initSocketConnection()
  //   }

  // }, [token])

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh'
        }}
      >
        <Header />
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            overflow: 'hidden'
          }}
        >
          <Sidebar />
          <Box
            sx={{
              flex: 1,
              // p: 3,
              overflow: 'auto'
            }}
          >
            {children || <Outlet />}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SidebarLayout;
